export const limits = [
  {
    id: 2,
    max_amount: 499,
    max_months_duration: 4,
  },
  {
    id: 3,
    max_amount: 999,
    max_months_duration: 9,
  },
  {
    id: 8,
    max_amount: 1499,
    max_months_duration: 18,
  },
  {
    id: 4,
    max_amount: 1999,
    max_months_duration: 24,
  },
  {
    id: 5,
    max_amount: 4999,
    max_months_duration: 36,
  },
  {
    id: 7,
    max_amount: 6999,
    max_months_duration: 48,
  },
  {
    id: 6,
    max_amount: 15000,
    max_months_duration: 60,
  },
]

export const loans = [
  {
    amountPaid: '£5,150.00',
    amountUnPaid: '£819.00',
    referenceID: 'UD00001',
  },
  {
    amountPaid: '£5,150.00',
    amountUnPaid: '£819.00',
    referenceID: 'UD00001',
  },
]

export const supportedBanks = [
  {
      "truelayer_id": "ob-hsbc",
      "truelayer_display_name": "HSBC",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-hsbc/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_HSBC.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-revolut",
      "truelayer_display_name": "Revolut",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-revolut/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_REVOLUT.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-tesco",
      "truelayer_display_name": "Tesco Bank",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-tesco/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_TESCO_BANK.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-rbs",
      "truelayer_display_name": "Royal Bank of Scotland",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-rbs/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_RBS.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-ms",
      "truelayer_display_name": "M&S Bank",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-ms/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_MS_BANK.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-capital-one",
      "truelayer_display_name": "Capital One",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-capital-one/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_CAPITAL_ONE.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-chase",
      "truelayer_display_name": "Chase",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-chase/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2Fchase_312_blue_bg.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-first-direct",
      "truelayer_display_name": "first direct",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-first-direct/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_FIRST_DIRECT.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-yorkshire-building-society",
      "truelayer_display_name": "Yorkshire Building Society",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-yorkshire-building-society/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_YBS.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-tsb",
      "truelayer_display_name": "TSB",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-tsb/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_TSB.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-mbna",
      "truelayer_display_name": "MBNA",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-mbna/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_MBNA.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-barclays",
      "truelayer_display_name": "Barclays",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-barclays/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2Fbarclays.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-chelsea-building-society",
      "truelayer_display_name": "Chelsea Building Society",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-chelsea-building-society/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_CBS.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-lloyds",
      "truelayer_display_name": "Lloyds",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-lloyds/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_LLOYDS.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-natwest",
      "truelayer_display_name": "NatWest",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-natwest/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_NATWEST.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-halifax",
      "truelayer_display_name": "Halifax",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-halifax/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_HALIFAX.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-ulster",
      "truelayer_display_name": "Ulster Bank",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-ulster/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_ULSTER_BANK.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-monzo",
      "truelayer_display_name": "Monzo",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-monzo/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_MONZO.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-barclaycard",
      "truelayer_display_name": "Barclaycard",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-barclaycard/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_BARCLAYCARD.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-virgin-money",
      "truelayer_display_name": "Virgin Money",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-virgin-money/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_VIRGIN_MONEY.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-nationwide",
      "truelayer_display_name": "Nationwide",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-nationwide/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2Fnationwide_logo_312.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-bos",
      "truelayer_display_name": "Bank of Scotland",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-bos/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_BOS.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-danske",
      "truelayer_display_name": "Danske Bank",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-danske/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_DANSKE_BANK.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-santander-personal",
      "truelayer_display_name": "Santander Personal",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-santander/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_SANTANDER.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-amex",
      "truelayer_display_name": "American Express",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-amex/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_AMEX_E5NR8at.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-cashplus",
      "truelayer_display_name": "Zempler (formerly Cashplus)",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-cashplus/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2Fzempler_formerly_cashplus_logo_312.png",
      "is_supported_by_truelayer": true
  },
  {
      "truelayer_id": "ob-starling",
      "truelayer_display_name": "Starling",
      "display_name": null,
      "country": "uk",
      "truelayer_logo_url": "https://providers-assets.truelayer.com/ob-starling/logo.svg",
      "logo_image": "https://transaction-master.api.updraft.co.uk/files/download/?name=banks.DBImage%2Fbytes%2Ffilename%2Fmimetype%2FGR_TRANS_STARLING_2.png",
      "is_supported_by_truelayer": true
  }
]

export const myHtml =
  '<?xml version="1.0" encoding="UTF-8"?>\n\n<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">\n\n<html xmlns="http://www.w3.org/1999/xhtml">\n  <head>\n    <title>Key Facts</title>\n\n    <style type="text/css">\n      strong {\n        color: black;\n      }\n\n      p {\n        color: 4 A4A4A;\n      }\n\n      h2 {\n        color: black;\n      }\n\n      h3 {\n        color: black;\n      }\n    </style>\n  </head>\n\n  <body>\n    <p>\n      <strong>Fixed Sum Loan Agreement regulated by the Consumer Credit Act 1974</strong>\n    </p>\n\n    <p><strong>Parties</strong></p>\n\n    <p>In this agreement,</p>\n\n    <p>\n      "We" are Fairscore Ltd, trading as Updraft and Onpath, c/o WeWork, 5 Merchant Square, London, W2 1AY;\n    </p>\n\n    <p>\n      "You" are aksjd kjk, Test Road, Testington, Testshire, TST1 1AB\n    </p>\n\n    <p><strong>How long will the agreement last?</strong></p>\n\n    <p>24 months</p>\n\n    <p>\n      This assumes the first repayment is exactly one month after you draw down your loan. The duration of the agreement\n      might be slightly longer or shorter depending on your choice of 1st payment date, but the number and amount of\n      repayments will be set out as below.\n    </p>\n\n    <p><strong>Loan Amount</strong></p>\n\n    <p>We are offering you an Updraft loan of &pound;1700.00.</p>\n\n    <p><strong>How and when will we give you the credit?</strong></p>\n\n    <p>\n      When you have signed the agreement, we will sign it. The agreement will start on that day and will end when you\n      have repaid everything you owe us.\n    </p>\n\n    <p>\n      We will pay the loan into the current account you gave in your application. This will usually be no more than 5\n      working days after the draw down date you asked for.\n    </p>\n\n    <p>\n      You may have the option of to pay off your credit card directly. If you do, you\'ll see this option in the app once\n      you\'ve signed your agreement.\n    </p>\n\n    <p><strong>How much will I be charged?</strong></p>\n\n    \n      <p>\n        We will charge a loan fee of &pound;85.00 which will be repayable over the life of the loan and is included in your monthly installment amount.\n      </p>\n    \n\n    <p>\n      We will charge you a fixed interest rate of 23.90 % per annum on your loan and on the loan fee.\n    </p>\n\n    <p>\n      Interest is calculated on a daily basis from the date of drawdown until the loan amount is fully repaid.\n    </p>\n\n    <p>\n      Monthly repayments: 23 instalment(s) of &pound;94.29\n      and one final instalment of &pound;65.90.\n    </p>\n\n    <p>\n      The monthly repayments may be more or less than the amount shown because we charge interest on the actual amount\n      you owe on a daily basis and this might change, for example, if we don\'t provide the loan immediately or you\n      overpay or underpay in any month.\n    </p>\n\n    <p>\n      If your financial circumstances change, we can reassess your account and reduce the interest rates that we charge\n      on the loan.\n    </p>\n\n    <p><strong>What is the total amount payable? </strong></p>\n\n    <p>Total amount payable &pound;2234.57</p>\n\n    <p><strong>What is the APR?</strong></p>\n\n    <p><b>33.75</b><b>% APR</b></p>\n\n    <p>APR assumptions:</p>\n\n    <p>\n      We work out interest and the APR as if the loan amount was reduced by each projected repayment, using the interest\n      rate, the number of monthly repayments and the period of the loan. For these purposes, we assume:\n    </p>\n\n    <ul>\n      <li>you draw down the loan on the date of the agreement;</li>\n      \n        <li>the loan fee is part of the total amount you will have to repay, but does not form part of the loan itself;</li>\n      \n\n      <li>payments start on the initial payment date;</li>\n\n      <li>the final payment made by you clears the balance of capital, interest and any other charges.</li>\n    </ul>\n\n    <p><strong>How will you repay the loan?</strong></p>\n\n    <p>\n      When you make a drawdown through the app, you will agree to the loan amount and monthly repayments based on the\n      selected term.\n    </p>\n\n    <p>The repayments will be taken via the Direct Debit you set up while signing up for the loan.</p>\n\n    <p>If the repayment date is on a non-working day, you can pay the following working day.</p>\n\n    <p>\n      After you have made your first repayment, you can change the monthly repayment date if you ask us. We may not be\n      able to change your next repayment date but we will change all subsequent repayment dates. You can only change the\n      date twice in any 12 month period. Changing the repayment date will impact the amount of interest on the loan.\n    </p>\n\n    <p><strong>What happens if I miss a payment? </strong></p>\n\n    <p>\n      We do not charge late payment fees but we will continue to charge interest on any unpaid balance at the rate\n      above.\n    </p>\n\n    <p>There may also be other consequences, such as:</p>\n\n    <ul>\n      <li>We may demand that you repay the loan immediately;</li>\n\n      <li>\n        Your credit rating may also be affected because we may disclose information about you and your conduct to credit\n        reference agencies. This may make obtaining credit in the future more difficult and/or expensive;\n      </li>\n\n      <li>\n        We can bring legal action to recover the loan (which could include asking a court to order that, if a property\n        you own is sold for any reason, some of the sale proceeds are used to repay this loan); and\n      </li>\n\n      <li>\n        You will also have to pay all reasonable costs, including legal advisors fees, that we incur in collecting any\n        unpaid amounts you owe.\n      </li>\n    </ul>\n\n    <p><strong>What happens if I change my mind?</strong></p>\n\n    <p>\n      You have the right to withdraw from the credit agreement, without having to give any reason, at any time within 14\n      days starting the day after the agreement is made.  We call this the "withdrawal period".\n    </p>\n\n    <p>You can withdraw from this agreement by:</p>\n\n    <ul>\n      <li>emailing us at loans@updraft.com; or</li>\n\n      <li>through the mobile app in-app chat functionality.</li>\n\n      <li>calling us on 0113 320 7310;</li>\n\n      <li>\n        writing to us at Fairscore Ltd, c/o WeWork, 5 Merchant Square, London, W2 1AY\n      </li>\n    </ul>\n\n    <p>\n      You must repay the total drawdown amount, without delay, within 30 days, starting the day after you tell us that\n      you want to withdraw. We won\'t charge any interest on your loan if you tell us you want to withdraw from this\n      agreement within the withdrawal period.  You will not pay the loan fee or any interest on the\n      loan fee if you withdraw from the credit agreement in this way.\n      You can find the details for repaying below under "Can I repay early?".\n    </p>\n\n    <p><strong>Can I repay early? </strong></p>\n\n    <p>\n      You can repay all or part of the outstanding amount early at any time. If you want to repay early, simply make a\n      payment to:\n    </p>\n\n    <p>Fairscore Ltd</p>\n\n    <p>Sort code : 04-00-72</p>\n\n    <p>Account no: 03183599</p>\n\n    <p>\n      The excess payments you make will trigger a recalculation of future repayments and reduce the loan duration.\n    </p>\n\n    <p><strong>How can I end this agreement?</strong></p>\n\n    <p>\n      To end this agreement, you will need to repay any outstanding drawdown balance on your account and you can then\n      cancel the agreement by letting us know:\n    </p>\n\n    <ul>\n      <li>through the mobile app in-app chat functionality;</li>\n\n      <li>email us at <a href="mailto:loans@updraft.com">loans@updraft.com</a>; or</li>\n\n      <li>Or Call us on 0113 320 7310 ;</li>\n    </ul>\n\n    <p><strong>How can you contact us? </strong></p>\n\n    <p>\n      If you need to contact us (for example, to update your contact details), you can:\n    </p>\n\n    <p>Through the in-app chat</p>\n\n    <p>Email us at <a href="mailto:loans@updraft.com">loans@updraft.com</a>;</p>\n\n    <p>Call us at 0113 320 7310</p>\n\n    <p>Or write to us at &ldquo;Fairscore Ltd, c/o WeWork, 5 Merchant Square, London, W2 1AY;&rdquo;</p>\n\n    <p><strong>What can I do if I have a complaint? </strong></p>\n\n    <p>\n      If you have a complaint about the service you\'ve received, please contact us at:\n    </p>\n\n    <p>Through the in-app chat</p>\n\n    <p>\n      Email us at\n\n      <a href="mailto:complaints@updraft.com">complaints@updraft.com</a>;\n    </p>\n\n    <p>Call us at 0113 320 7310</p>\n\n    <p>\n      Or write to us at &ldquo;Fairscore Ltd, c/o WeWork, 5 Merchant Square, London, W2 1AY;&rdquo;\n    </p>\n\n    <p>\n      If we\'re unable to resolve your complaint, you may have a right to refer your complaint to the Financial Ombudsman\n      Service by:\n    </p>\n\n    <ul>\n      <li>\n        Writing to them at The Financial Ombudsman Service, Exchange Tower, London, E14 9SR\n      </li>\n\n      <li>Calling them on 0800 023 4567</li>\n\n      <li>\n        Emailing them at\n\n        <a href="mailto:complaint.info@financialombudsman.org.uk">complaint.info@financialombudsman.org.uk</a>\n      </li>\n    </ul>\n\n    <p>The FOS website is financial-ombudsman.org.uk</p>\n\n    <p>\n      If you do not take up your complaint with us first, you will not be entitled to refer it to the Financial\n      Ombudsman Service.\n    </p>\n\n    <p><strong>How can you keep track of what you owe?</strong></p>\n\n    <p>You may ask us at any time for a statement of account.</p>\n\n    <p>This shows:</p>\n\n    <ul>\n      <li>Details (including the amounts) of repayments you still owe,</li>\n\n      <li>The dates on which each repayment is due; and</li>\n\n      <li>\n        A breakdown of each repayment showing how much comprises capital, interest and, if applicable, other charges\n      </li>\n    </ul>\n\n    <p>We will not charge for the statement.</p>\n\n    <p><strong>How are we supervised?</strong></p>\n\n    <p>\n      We are regulated by the Financial Conduct Authority, 12 Endeavour Square, London, E20 1JN, which is the\n      supervisory authority under the Consumer Credit Act 1974. Our Financial Services Register no. is 810923.\n    </p>\n\n    <p>\n      You can check these details by visiting the Financial Conduct Authority website www.fca.org.uk or by contacting\n      the Financial Conduct Authority on 0800 111 6768.\n    </p>\n\n    <p><strong>What law governs this agreement?</strong></p>\n\n    <p>\n      This agreement is governed by the law of England &amp; Wales.\n    </p>\n\n    <p>Disputes will be referred to the courts of England &amp; Wales unless you reside in Scotland or Northern Ireland,\n      in which case your local courts shall have jurisdiction\n    </p>\n\n    <p><strong>What language will we use to communicate with you?</strong></p>\n\n    <p>We will communicate with you at all times in English.</p>\n\n    <p><strong>Can we transfer our rights under this agreement?</strong></p>\n\n    <p>\n      We may transfer our rights and our obligations under this agreement to a third party, including information about\n      you and how you have managed the loan which the third party needs to know. Your rights under this agreement and\n      your legal rights (including under the Consumer Credit Act 1974) won\'t be affected by such a transfer.\n    </p>\n\n    <p>\n      You won\'t be able to transfer any rights you have against us to anyone else.\n    </p>\n\n    <p>\n      If we choose not to enforce our rights under this agreement at any time, we may enforce them at a later date\n      instead.\n    </p>\n\n    \n\n    <p>&nbsp;</p>\n\n    \n  </body>\n</html>\n'

export const titleoptions = [
  {
    label: 'Mr',
    value: 'Mr',
  },
  {
    label: 'Mrs',
    value: 'Mrs',
  },
  {
    label: 'Miss',
    value: 'Miss',
  },
  {
    label: 'Ms',
    value: 'Ms',
  },
  {
    label: 'Dr',
    value: 'Dr',
  },
]

export const numberWithCommonAndPannie = (e, handleChange) => {
  const newValue = e.target.value.replace(/,/g, '') // Remove commas

  // Check for decimal places and limit to 2 if necessary
  if (newValue.indexOf('.') !== -1 && newValue.split('.')[1].length > 2) {
    const formattedValue = parseFloat(newValue).toFixed(2)
    e.target.value = formattedValue
  } else {
    e.target.value = newValue
  }
  !isNaN(e.target.value) && handleChange(e)
}

export const storeBankPayOffData = () => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    const value = localStorage.getItem(key)
    try {
      const parsedObject = JSON.parse(value)

      if (
        parsedObject &&
        Object.prototype.hasOwnProperty.call(parsedObject, 'days_to_renew')
      ) {
        for (let i = 0; i < localStorage.length; i++) {
          const x = localStorage.key(i)
          if (x !== 'reason' && x !== x) {
            localStorage.removeItem(x)
          }
        }
        // Use the found value as needed
        break // Exit the loop once found
      } /* else {
        for (let i = 0; i < localStorage.length; i++) {
          const x = localStorage.key(i)
          if (x !== 'reason') {
            localStorage.removeItem(x)
          }
        }
      } */
    } catch (error) {
      // Not a JSON string, ignore or handle differently
    }
  }
}

export const removeGarbage = () => {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    const value = localStorage.getItem(key)
    try {
      const parsedObject = JSON.parse(value)

      if (
        parsedObject &&
        Object.prototype.hasOwnProperty.call(parsedObject, 'days_to_renew')
      ) {
        localStorage.removeItem(key)
        // Use the found value as needed
        break // Exit the loop once found
      }
    } catch (error) {
      // Not a JSON string, ignore or handle differently
    }
  }
}

export const removeAllGarbage = () => {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i)
    try {
      const parsedObject = JSON.parse(localStorage.getItem(key))

      if (parsedObject && Object.hasOwn(parsedObject, 'days_to_renew')) {
        localStorage.removeItem(key)
      }
    } catch (error) {
      // Not a JSON string, ignore or handle differently
    }
  }
}
